/** Auth API paths that are intentionally unauthenticated. */
export const PUBLIC_AUTH_PATHS = [
  "/login",
  "/register",
  "/captcha",
  "/confirm-account",
  "/reset-password",
  "/confirm-reset-password",
  "/resend-confirmation-otp",
  "/verify-totp",
] as const;

/** RTK Query endpoint names that must not trigger session reset on 401. */
export const PUBLIC_AUTH_ENDPOINTS = new Set([
  "login",
  "register",
  "registerInvitedUser",
  "captcha",
  "confirmAccount",
  "resetPassword",
  "confirmResetPassword",
  "resendConfirmationOtp",
  "verifyTotp",
]);

export const HTTP_UNAUTHORIZED = 401;
